import React from 'react';
import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';

import Dawa_full_case from '../../assets/images/Dawa-full-case-study.png'
import dawa_logo from '../../assets/images/Dawa-large.png'
import './style.css'
import '../page-style.css'
import { useNavigate } from 'react-router-dom';
import Dawa_full_case_study from '../../assets/downloads/Dawa-Full-casestudy.pdf';
import Dawa_Summary from '../../assets/downloads/Dawa-Summary.pdf';
import {BsArrowLeft} from 'react-icons/bs';
const P1 = "Dawa Life Sciences is a high-growth Kenya-based pharmaceutical manufacturer founded by Dr. Mohindra and Dr Patel through the acquisition of Dawa Pharmaceuticals and merger with Medisel Kenya Limited"
const P2 = "An Emerging Giant– Dawa Life Science’s journey from a trading business to a leading Pharmaceutical manufacturer"
const P3 = "An Emerging Giant– Dawa Life Science’s journey from a trading business to a leading Pharmaceutical manufacturer"

export const DAWASciences = () => {

    const navigate = useNavigate();
    const handleEnter = ()=>{
        navigate("/case-studies")
    }
    const onButtonClick = (typeOfCase) => {
        fetch(typeOfCase).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = typeOfCase;
                alink.click();
            })
        })
    }
    return (
        <div className={'main'}>
            <Navbar whiteText={false} className={'home-navbar'} />
            <div className='section-Study'>      
                <div className='study-img-card'>
                    <img src={dawa_logo} alt={'ubi'} className='ubi-enegry-image' /> 
                    <div className='ubi-text'>
                        Dawa Life Sciences
                    </div>
                    <div className= 'casestudy-text'> {P1}</div> 
                </div>

                <div className='card'>
                    <div className='study-container study-card'>
                        <img className='book-pic' alt='book-pic' src={Dawa_full_case} />
                        <h1 className='case-study-header'>Dawa Life Sciences: Full case study</h1>
                        <p className='case-page-text partner-text'>
                            {P2}
                        </p>
                        <button className='download-casestudy hover-green'onClick={() => onButtonClick(Dawa_full_case_study)}>Download full case study</button>
                    </div>
                    
                    <div className='study-container study-card'>
                        <img className='book-pic' alt='book-pic' src={Dawa_full_case} />
                        <h1 className='case-study-header'>Dawa Life Sciences: Executive Summary</h1>
                        <p className='case-page-text partner-text'>
                            {P3}
                        </p>
                        <button className='download-casestudy hover-green' onClick={() => onButtonClick(Dawa_Summary)}>Download executive summary</button>
                    </div>
                    
                </div>
            </div>

           <div className='section-stats'>
            <div className='stat'>
                <h1 className='stat-header'>
                    1994
                </h1>
                <p1 className="stat-text">
                     Year founded
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                    100m+
                </h1>
                <p1 className = "stat-text">
                    packs of medication per year supply capacity
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                    $60m+
                </h1>
                <p1 className="stat-text" >
                    Revenue in 2020
                </p1>
            </div>
           </div>
            <div className='doc'>
                <h1 className='doc-text'>Watch the documentary</h1>
            </div>
            <div className='vid-frame videoWrapper'>
                <iframe className='yt-vid' width="1450" height="815" src="https://www.youtube.com/embed/7LwYUmkW4DA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture & muted=1" allowfullscreen></iframe>
            </div>
            <div className='back-to-casestudy'>
                 <button className="btn btn-back-to-casestudy" onClick={handleEnter}>
                    <div className='back-btns'>
                        <BsArrowLeft className='arrow'/>
                        <div className='back-text'>
                            Back to casestudy
                        </div>
                    </div>
                    </button>
            </div>
            <Footer />
        </div>
    )
}